
import $ from 'jquery';
import { throttle } from 'Util/throttle';
import { subscribe } from 'Util/pubsub';

let classes;

let $window;
let $body;
let $header;
let $notification;

let headerHeight;

let ignoreNextScroll = false;

let didScroll;
let lastScrollTop = $('body, html').scrollTop();

const delta = 5;

const module = {
	init: function (selectors, classList) {
		$body = $('body');
		classes = classList;

		module._initElements(selectors);
		module._initSubscriptions();
		module._initEvents();

		$(document).ready(() => {
			module._adjustForTarget(true);
		});

		module._setScrollListener();
		module._setStickiness();
	},

	_initElements: function (selectors) {
		$window = $(window);
		$header = $(selectors.header);
		$notification = $(selectors.notification);

		headerHeight = $header.outerHeight();
	},

	_initSubscriptions: function () {
		subscribe('/window/scroll', module._handleScroll);
	},

	_initEvents: function () {
		// _adjustForTarget is minimally throttled so both events won't fire at once
		// The click event fires once, before scroll,
		// then the hashchange event fires after scroll but only
		// if the hash has changed

		$(document).on('click', 'a[href^="#"]:not([href="#"])', module._adjustForTarget);
		$(window).on('hashchange', module._adjustForTarget);
	},

	_adjustForTarget: throttle((e) => {

		const initialLoad = e === true;

		const $target = $(':target');
		let targetScrollTop;

		if (initialLoad) {
			ignoreNextScroll = true;
		}

		if ($target.length) {
			targetScrollTop = $target.offset().top;

			if (targetScrollTop < lastScrollTop || initialLoad) {
				module._applyStickyOffset(initialLoad);

				if (!initialLoad && e.type === 'click') {
					e.preventDefault();
				}
			}
		}
	}, 10),

	_applyStickyOffset: function (initialLoad) {
		const $target = $(':target');

		const offset = $header.outerHeight();

		const targetOffset = $target.offset().top;
		const newScrollTop = targetOffset - offset;

		let shouldAdjust = true;
		let scrollTop;
		let diff;

		if (initialLoad) {
			scrollTop = $('body, html').scrollTop();
			diff = Math.abs(scrollTop - targetOffset);

			if (diff > 20) {
				// Just loaded the page, but scroll is not near the target.
				// Assume this means the page was refreshed and inherited its
				// prior scroll position.
				shouldAdjust = false;
			}
		}

		if (shouldAdjust) {
			$('html, body').scrollTop(newScrollTop);
		}
	},

	_setScrollListener: () => {
		setInterval(
			() => {
				if (didScroll) {
					module._hasScrolled();
					didScroll = false;
				}
			},
			250
		);
	},

	_handleScroll: function () {
		module._setDidScroll();
		module._setStickiness();
	},

	_setDidScroll: function () {
		didScroll = true;
	},

	_setStickiness: function () {

		const isSticky = $header.hasClass(classes.headerSticky);
		const notificationHeight = $notification.outerHeight() || 1;
		const scrollTop = $window.scrollTop();
		const shouldBeSticky = scrollTop >= notificationHeight;

		if (isSticky !== shouldBeSticky) {
			if (shouldBeSticky) {
				$header.addClass(classes.headerSticky);
			} else {
				$header.removeClass(classes.headerSticky);
			}
		}
	},

	_hideHeader: function () {
		$header.removeClass(classes.headerDown).addClass(classes.headerUp);
	},

	_hasScrolled: function () {
		if (ignoreNextScroll) {
			ignoreNextScroll = false;
			return;
		}

		const scrollTop = $window.scrollTop();

		// Make sure they scroll more than delta
		if (Math.abs(lastScrollTop - scrollTop) <= delta || $body.hasClass(classes.dropdownOpen)) {
			return false;
		}

		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
			// Scroll Down
			$header.addClass(classes.headerUp);
			$header.removeClass(classes.headerDown);

		} else if (scrollTop + $window.height() < $(document).height()) {
			// Scroll Up
			if (scrollTop > headerHeight) {
				$header.addClass(classes.headerDown);
			} else {
				$header.removeClass(classes.headerDown);
			}

			$header.removeClass(classes.headerUp);
		}

		lastScrollTop = scrollTop;
	}
};

const HeaderSticky = {
	init: module.init
};

export { HeaderSticky };
